<template>
  <div class="nx-search-wrapper bj-small-card">
    <div ref="nxSearch" class="nx-search">
      <bj-form
        ref="searchForm"
        :source="source"
        :config="config"
        labelWidth="auto"
      >
        <div slot="search" class="nx-form__operation">
          <slot name="search">
            <el-button type="primary">查询</el-button>
          </slot>
        </div>
      </bj-form>
    </div>
    <div v-if="hasHidden" class="hidden-wrapper">
      <i v-if="!hidden" class="el-icon-arrow-up" @click="hidden = true"></i>
      <i v-else class="el-icon-arrow-down" @click="hidden = false"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BjSearch',
  components: {
  },
  props: {
    source: {
      type: Object,
      default: () => ({})
    },
    config: {
      type: Array,
      default: () => []
    },
    hasHidden: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      hidden: false,
      searchHeight: 'auto'
    };
  },
  computed: {
  },
  // watch: {
  //   hidden: {
  //     handler() {
  //       setTimeout(() => {
  //         this.$emit('hiddenChange');
  //       }, 300);
  //     }
  //   }
  // },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.searchHeight = this.$refs.nxSearch.clientHeight + 'px';
    });
  },
  methods: {
    resetFields() {
      this.$refs.searchForm.resetFields();
    }
  }
};
</script>
<style lang="less">
  .nx-search{
    .el-form-item{
      display: flex;
    }
    .el-form-item__content{
      -webkit-box-flex: 1;
      -ms-flex: 1 1;
      flex: 1 1;
      vertical-align: middle;
    }
  }
</style>
<style scoped lang="less">
.nx-search-wrapper{
  display: flex;
  flex-direction: column;
}
.nx-search{
  transition: all .3s;
  overflow: hidden;
  &.hidden{
    height: 0;
  }
}
.hidden-wrapper{
  display: flex;
  justify-content: center;
  font-size: 20px;
}
</style>
